module.exports = __webpack_public_path__ + "img/spin_btn.7e97745a.png";